import { message, Select, Checkbox, Col, Row, Form as FormInitial, Tabs, Upload, Popconfirm, } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem, ModalItem, ButtonItem, InputItem, SelectItem, cuentaMask,
  BoxItem, HeaderItem, Form, SwitchItem, TableItemDinamico,
  ErrorItem,
  extraerDatosConstanciaFiscal,
  calcularSimilitud
} from "../../../../../Components/Items";
import ModalInsumoParaCliente from "../../../../../Components/ModalInsumoParaCliente";
import SeccionSubirInsumosCliente from "../../../../../Components/SeccionSubirInsumosCliente";
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getDefaultCamposObligatorios } from "../../../Clientes/camposClientesConfig";

const { Option } = Select;
const { TabPane } = Tabs;

// Columnas con buscador en la tabla de Insumos x Cliente (mismas que en Editar Cliente)
const CAMPOS_BUSCABLES_INSUMOS = ["claveInterna", "descripcion", "nombreAlternativo", "clave", "unidadNombre"];

class AgregarCliente extends Component {
  formRef = React.createRef();
  paramsInsumosPersonalizados = null;

  state = {
    loading: false,
    visible: this.props.visible,
    tipoPersona: [],
    todasUsosDeCFDI: null,
    todasTipoDeCliente: null,
    todasCuentaContable: null,
    todasPaises: null,
    todasRegimenFiscal: null,
    todasVendedores: null,
    objetoRegimenFiscal: [],
    objetoUsosDeCFDI: [],
    objetoTipoDeCliente: [],
    objetoPaises: [],
    objetoCuentaContable: [],
    objetoVendedores: [],
    objetoCanalesVenta: [],
    objetoColonias: [],
    objetoMunicipios: [],
    objetoEstados: [],
    objetoRetenciones: null,
    todasRetenciones: [],
    camposObligatorios: getDefaultCamposObligatorios(),

    // Insumos x Cliente (se maneja en memoria porque el cliente aún no existe hasta guardar)
    insumosPersonalizados: [],
    insumosPersonalizadosVista: [],
    insumosPersonalizadosTotal: 0,
    modalInsumoPersonalizadoVisible: false,
    insumoPersonalizadoEditando: null,
    todasUnidades: [],
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.consultarTodo();
      this.setState({ visible: this.props.visible });
    }
  }

  async consultarTodo() {
    await this.setState({ loading: true });
    axios.post("unidades/selectUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ todasUnidades: res.data });
        }
      });
    axios.post("clientes/selectDatosParaCliente", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            loading: false,
            todasUsosDeCFDI: res.data.usosDeCFDI,
            todasTipoDeCliente: res.data.tipoDeClientes,
            todasCuentaContable: res.data.cuentasContables,
            todasPaises: res.data.paises,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasVendedores: res.data.vendedores,
            todasRetenciones: res.data.retenciones,
            objetoPaises: res.data.paises.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre + " - " + value.abreviatura}</Option>
            )),
            objetoEstados: res.data.estados.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre + " - " + value.abreviatura}</Option>
            )),
            objetoCuentaContable: res.data.cuentasContables.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
            objetoTipoDeCliente: res.data.tipoDeClientes.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre + " - " + value.descripcion}</Option>
            )),
            objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => (
              <Option value={value._id} key={value._id}>{value?.c_UsoCFDI + ' - ' + value.descripcion}</Option>
            )),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => (
              <Option value={value._id} key={value._id}>{value.c_RegimenFiscal + " - " + value.descripcion}</Option>
            )),
            objetoVendedores: res.data.vendedores.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
              </Option>
            )),
            objetoCanalesVenta: res.data.canalesVenta?.map((value) => (
              <Option value={value._id} key={value._id}>{value.codigo + " - " + value.nombre}</Option>
            )),
            objetoRetenciones: res.data.retenciones.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            camposObligatorios: res.data.camposObligatorios || getDefaultCamposObligatorios(),
          });
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.error("Error en la consulta:", error);
        this.setState({ loading: false });
      });
  }

  onChangeEstado(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === 'undefined') {
        direcciones[fieldKey] = {}
      }
      direcciones[fieldKey].municipioId = undefined;
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
      let objetoColonias = this.state.objetoColonias;
      objetoColonias[fieldKey] = null;
      this.setState({ objetoColonias: objetoColonias });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          let objetoMunicipios = this.state.objetoMunicipios;
          objetoMunicipios[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }

  async onChangeRfc(e) {
    this.formRef.current.validateFields(['rfc']).then(() => {
      if (e.target.value) {
        if (e.target.value.length === 13) {
          //Persona Fisica
          this.formRef.current.setFieldsValue({ persona: false })
        } else if (e.target.value.length === 12) {
          //Persona Moral
          this.formRef.current.setFieldsValue({ persona: true })
        }
      }
    }).catch((err) => undefined)
  }

  onChangeMunicipio(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === 'undefined') {
        direcciones[fieldKey] = {}
      }
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          let objetoColonias = this.state.objetoColonias;
          objetoColonias[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoColonias: objetoColonias,
          });
        }
      });
  }


  async onSearchColonia(value, fieldKey, ponerColoniaId) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            let direcciones = this.formRef.current.getFieldValue("direcciones");
            if (typeof direcciones[fieldKey] === 'undefined') {
              direcciones[fieldKey] = {}
            }
            if (ponerColoniaId && res.data._id) {
              direcciones[fieldKey].coloniaId = res.data._id
            }
            direcciones[fieldKey].paisId = res.data.paisId
            direcciones[fieldKey].estadoId = res.data.estadoId
            direcciones[fieldKey].municipioId = res.data.municipioId
            this.formRef.current.setFieldsValue({
              direcciones: direcciones,
            });
            this.onChangeEstado(res.data.estadoId, fieldKey, true);
            this.onChangeMunicipio(res.data.municipioId, fieldKey, true);
          }
        });
    }
  }
  async onSelectColoniaId(coloniaId, fieldKey) {
    const direcciones = this.formRef.current.getFieldValue('direcciones')
    if (typeof direcciones[fieldKey] === 'undefined') {
      direcciones[fieldKey] = {}
    }
    if (!direcciones[fieldKey].colonia) {
      const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
      direcciones[fieldKey].colonia = nombreColonia
      await this.formRef.current.setFieldsValue({
        direcciones: direcciones
      })
    }
  }

  onFinishFailed = (errorInfo) => {
    ErrorItem(errorInfo)
  };

  onFinish = (values) => {
    this.setState({ loading: true });
    axios.post("clientes/agregarCliente", { ...values, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const nuevoClienteId = res.data.codigo;
          const insumosPersonalizados = this.state.insumosPersonalizados;
          if (insumosPersonalizados.length > 0) {
            // El cliente ya quedo guardado, asi que esto no bloquea el cierre del modal;
            // pero si el bulk rechaza la lista hay que decirlo o los insumos se pierden
            // en silencio y el usuario cree que quedaron
            axios.post(
              "insumosCliente/agregarInsumosPersonalizadosClienteBulk",
              { empresaId: this.props.empresaId, clienteId: nuevoClienteId, lista: insumosPersonalizados },
              { headers: this.props.headersToken }
            ).then((resInsumos) => {
              if (resInsumos.data.success !== 2) {
                message.warning(resInsumos.data.message || "El cliente se guardó, pero sus insumos no. Agrégalos desde Editar Cliente.");
              } else if (resInsumos.data.omitidos > 0) {
                message.warning(`El cliente se guardó con ${resInsumos.data.agregados} insumo(s); se omitieron ${resInsumos.data.omitidos}.`);
              }
            }).catch(() => {
              message.warning("El cliente se guardó, pero sus insumos no. Agrégalos desde Editar Cliente.");
            });
          }
          this.setState({ loading: false });
          message.success("Se ha registrado un cliente");
          this.formRef.current.resetFields();
          this.cerrarModal(nuevoClienteId);
        } else if (res.data.success === 1) {
          this.setState({ loading: false });
          message.warning(res.data.message ? res.data.message : "No se puede registrar el cliente");
        } else {
          this.setState({ loading: false });
          message.error("Hubo un error y el cliente no se registró");
        }
      });
  };

  cerrarModal = (id) => {
    this.paramsInsumosPersonalizados = null;
    this.setState({ visible: false, insumosPersonalizados: [], insumosPersonalizadosVista: [], insumosPersonalizadosTotal: 0 });
    this.props.cerrarModal(id);
    this.formRef.current.resetFields();
  };

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (e.file.type === "application/pdf") {
      const datosConstancia = await extraerDatosConstanciaFiscal(e.file)
      if (datosConstancia.persona === 1) {


        if (datosConstancia.rfc && datosConstancia.nombre && datosConstancia.apellidoPaterno && datosConstancia.codigoPostal) {
          const findRegimen = this.state.todasRegimenFiscal.find(valueTRe => calcularSimilitud(valueTRe.descripcion, datosConstancia.regimenFiscal) > 65)
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true)
          this.formRef.current.setFieldsValue({
            rfc: datosConstancia.rfc,
            curp: datosConstancia.curp,
            nombre: datosConstancia.nombre,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            apellidoPaterno: datosConstancia.apellidoPaterno,
            apellidoMaterno: datosConstancia.apellidoMaterno,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              }
            ],
            persona: false
          })

        } else {
          message.error('No se pudo leer bien el archivo')
        }

      } else if (datosConstancia.persona === 2) {

        if (datosConstancia.rfc && datosConstancia.razonSocial && datosConstancia.codigoPostal) {
          this.onSearchColonia(datosConstancia.codigoPostal, 0, true)
          const findRegimen = this.state.todasRegimenFiscal.find(valueTRe => calcularSimilitud(valueTRe.descripcion, datosConstancia.regimenFiscal) > 65)
          this.formRef.current.setFieldsValue({
            razonSocial: datosConstancia.razonSocial,
            rfc: datosConstancia.rfc,
            regimenFiscalId: findRegimen ? findRegimen._id : undefined,
            curp: datosConstancia.curp,
            nombreComercial: datosConstancia.nombreComercial,

            direcciones: [
              {
                calle: datosConstancia.calle,
                numeroCalle: datosConstancia.numeroExterior,
                numeroInterior: datosConstancia.numeroInterior,
                colonia: datosConstancia.colonia,
                codigoPostal: datosConstancia.codigoPostal,
              }
            ],
            persona: true
          })
        } else {
          message.error('No se pudo leer bien el archivo')
        }

      } else {
        message.error('No se pudo leer bien el archivo')
      }
    } else {
      message.error("El archivo debe ser un archivo pdf");
    }
    this.setState({ loading: false });
  }

  onChangeTipoDeCliente(value) {
    const tipoDeCliente = this.state.todasTipoDeCliente.find(
      (valueTodos) => valueTodos._id.toString() === value.toString()
    );
    if (tipoDeCliente.generarCuentasAutomatico) {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: "Se generara al guardarlo",
        cuentaAnticipoId: "Se generara al guardarlo",
        generarCuentaAnticipoId: false,
        cuentaFonGarId: "Se generara al guardarlo",
        generarCuentaFonGarId: false,
        cuentaDeudorId: "Se generara al guardarlo",
        generarCuentaDeudorId: false,
      });
    } else {
      this.formRef.current.setFieldsValue({
        cuentaClienteId: tipoDeCliente.cuentaClienteId,
        cuentaAnticipoId: tipoDeCliente.cuentaAnticipoId,
        generarCuentaAnticipoId: false,
        cuentaFonGarId: tipoDeCliente.cuentaFonGarId,
        generarCuentaFonGarId: false,
        cuentaDeudorId: tipoDeCliente.cuentaDeudorId,
        generarCuentaDeudorId: false,
      });
    }
  }


  onChangeRegimenFiscal(regimenFiscalId) {
    const retencionAgregar = this.state.todasRetenciones.find(todasRetenciones => todasRetenciones.regimenFiscalId.toString() === regimenFiscalId.toString())
    const retenciones = this.formRef.current.getFieldValue('retenciones')
    if (retencionAgregar) {
      if (retenciones) {
        const findRetencion = retenciones.find(todasRetencionesProv => todasRetencionesProv.retencionId.toString() === retencionAgregar._id.toString())
        if (!findRetencion) {
          this.formRef.current.setFieldsValue({
            retenciones: [...retenciones, { retencionId: retencionAgregar._id }]
          })
        }
      } else {
        this.formRef.current.setFieldsValue({
          retenciones: [{ retencionId: retencionAgregar._id }]
        })
      }
    }
  }


  actualizarVistaInsumosPersonalizados(params) {
    // La lista vive en memoria hasta que se guarda el cliente, asi que la tabla se pagina y
    // se filtra aqui. Se recuerdan los ultimos parametros para no perder los buscadores ni la
    // pagina cuando se llama sin argumentos (al agregar, eliminar o subir por Excel)
    if (params) this.paramsInsumosPersonalizados = params;
    const paramsActuales = this.paramsInsumosPersonalizados || {};

    const pageSize = paramsActuales.pageSize || 10;
    const page = paramsActuales.page || 1;
    const inicio = (page - 1) * pageSize;

    const filtrados = this.filtrarInsumosPersonalizados(
      this.state.insumosPersonalizados,
      paramsActuales.filters
    );

    this.setState({
      insumosPersonalizadosVista: filtrados.slice(inicio, inicio + pageSize),
      insumosPersonalizadosTotal: filtrados.length,
    });
  }

  filtrarInsumosPersonalizados(insumos, filters) {
    if (!filters) return insumos;

    // TableItemDinamico manda el valor como texto o como arreglo (["texto"])
    const buscados = CAMPOS_BUSCABLES_INSUMOS.map((campo) => {
      const valor = Array.isArray(filters[campo]) ? filters[campo][0] : filters[campo];
      const texto = valor === undefined || valor === null ? "" : String(valor).trim().toLowerCase();
      return { campo, texto };
    }).filter((filtro) => filtro.texto);

    if (buscados.length === 0) return insumos;

    return insumos.filter((insumo) =>
      buscados.every(({ campo, texto }) => String(insumo[campo] ?? "").toLowerCase().includes(texto))
    );
  }

  abrirModalInsumoPersonalizado(item) {
    this.setState({
      modalInsumoPersonalizadoVisible: true,
      insumoPersonalizadoEditando: item || null,
    });
  }

  cerrarModalInsumoPersonalizado() {
    this.setState({
      modalInsumoPersonalizadoVisible: false,
      insumoPersonalizadoEditando: null,
    });
  }

  resolverUnidadNombre(unidadId) {
    if (!unidadId) return undefined;
    const unidad = this.state.todasUnidades.find((u) => u._id === unidadId);
    return unidad ? `${unidad.unidadSat.c_ClaveUnidad} - ${unidad.nombre}` : undefined;
  }

  // La lista vive en memoria y un mismo insumo puede aparecer en varios renglones (otra
  // clave del cliente, otra presentación, otro precio), así que el renglón necesita una
  // llave propia: ni editar ni eliminar pueden buscar por insumoId
  nuevaKeyInsumoPersonalizado() {
    this.contadorInsumosPersonalizados = (this.contadorInsumosPersonalizados || 0) + 1;
    return `ip_${this.contadorInsumosPersonalizados}`;
  }

  guardarInsumoPersonalizado(valores) {
    const { insumoId, insumo, nombreAlternativo, clave, precio, unidadId, conversion } = valores;
    if (!insumoId || !nombreAlternativo?.trim()) {
      return message.warning('Selecciona un insumo y captura el nombre para el cliente');
    }
    const { insumoPersonalizadoEditando, insumosPersonalizados } = this.state;
    const unidadNombre = this.resolverUnidadNombre(unidadId);
    let nuevaLista;
    if (insumoPersonalizadoEditando) {
      nuevaLista = insumosPersonalizados.map((item) =>
        item._key === insumoPersonalizadoEditando._key
          ? { ...item, insumoId, claveInterna: insumo?.clave, descripcion: insumo?.descripcion, nombreAlternativo: nombreAlternativo.trim(), clave, precio, unidadId, unidadNombre, conversion: conversion || 1 }
          : item
      );
    } else {
      // Repetir el insumo está permitido: sólo se avisa (el modal ya lo marcó en amarillo)
      if (insumosPersonalizados.some((item) => item.insumoId === insumoId)) {
        message.warning('Ese insumo ya estaba en la lista: se agregó otro renglón aparte.');
      }
      nuevaLista = [
        ...insumosPersonalizados,
        {
          _key: this.nuevaKeyInsumoPersonalizado(),
          insumoId,
          nombreAlternativo: nombreAlternativo.trim(),
          clave,
          precio,
          unidadId,
          unidadNombre,
          conversion: conversion || 1,
          claveInterna: insumo?.clave,
          descripcion: insumo?.descripcion,
        },
      ];
    }
    this.setState({ insumosPersonalizados: nuevaLista }, () => {
      this.actualizarVistaInsumosPersonalizados();
      this.cerrarModalInsumoPersonalizado();
    });
  }

  eliminarInsumoPersonalizado(item) {
    const nuevaLista = this.state.insumosPersonalizados.filter((value) => value._key !== item._key);
    this.setState({ insumosPersonalizados: nuevaLista }, () => this.actualizarVistaInsumosPersonalizados());
  }

  confirmarSubidaExcelInsumos(filas, limpiarSeccion) {
    const { insumosPersonalizados } = this.state;
    const yaExistentes = new Set(insumosPersonalizados.map((item) => item.insumoId));
    let repetidos = 0;

    // Ningún renglón se descarta por repetir insumo; sólo se cuenta para el aviso
    const nuevos = filas.map((fila) => {
      if (yaExistentes.has(fila.insumoId)) repetidos++;
      return {
        _key: this.nuevaKeyInsumoPersonalizado(),
        insumoId: fila.insumoId,
        nombreAlternativo: fila.nombreAlternativo.trim(),
        clave: fila.clave,
        precio: fila.precio,
        unidadId: fila.unidadId,
        unidadNombre: this.resolverUnidadNombre(fila.unidadId),
        conversion: fila.conversion || 1,
        claveInterna: fila.claveInterna,
        descripcion: fila.descripcion,
      };
    });

    this.setState({ insumosPersonalizados: [...insumosPersonalizados, ...nuevos] }, () => {
      this.actualizarVistaInsumosPersonalizados();
    });
    message.success(
      `Se agregaron ${nuevos.length} insumo(s)${repetidos > 0 ? `, ${repetidos} de insumos que ya estaban en la lista` : ''}`
    );
    if (limpiarSeccion) limpiarSeccion();
  }

  render() {
    const { camposObligatorios } = this.state;
    return (
      <ModalItem
        title="Agregar Cliente"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        footer={null}
        width={800}
        zIndex={this.props.zIndex}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarCliente"
          layout
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Tabs defaultActiveKey="1" tabBarExtraContent={
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={[]}
              customRequest={this.onChangeArchivo.bind(this)}
              accept=".pdf"
            >
              <ButtonItem blanco icon={<UploadOutlined />}>Leer Constancia</ButtonItem>
            </Upload>
          }>
            <TabPane tab="General" key="1" forceRender>

              <FormItem
                name="persona"
                label="P. Moral"
                valuePropName="checked"
                initialValue={false}
                margin
              >
                <Checkbox />
              </FormItem>

              <FormItem
                label="RFC"
                name="rfc"
                required
                margin
                rfc
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem onChange={this.onChangeRfc.bind(this)} placeholder="RFC" />
              </FormItem>


              <FormItem shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  if (getFieldValue("persona")) {
                    return (
                      <FormItem
                        label="Razon Social"
                        margin
                        pattern
                        required
                        max={200}
                        name="razonSocial"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                      >
                        <InputItem placeholder="Razón Social" />
                      </FormItem>
                    );
                  }
                }}
              </FormItem>

              <Row>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (!getFieldValue("persona")) {
                        return (
                          <FormItem
                            label="Nombre"
                            margin
                            pattern
                            required
                            name="nombre"
                            labelCol={{ span: 12 }}
                            wrapperCol={{ span: 12 }}
                          >
                            <InputItem
                              placeholder="Nombre persona física"
                              width="98%"
                            />
                          </FormItem>
                        );
                      }
                    }}
                  </FormItem>
                </Col>
                <Col span={6} xs={24} sm={24} lg={6} xl={6}>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (!getFieldValue("persona")) {
                        return (
                          <FormItem
                            margin
                            pattern
                            name="apellidoPaterno"
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <InputItem
                              placeholder="Apelido Paterno"
                              width="98%"
                            />
                          </FormItem>
                        );
                      }
                    }}
                  </FormItem>
                </Col>
                <Col span={6} xs={24} sm={24} lg={6} xl={6}>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (!getFieldValue("persona")) {
                        return (
                          <FormItem
                            margin
                            pattern
                            name="apellidoMaterno"
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}
                          >
                            <InputItem placeholder="Apellido Materno" />
                          </FormItem>
                        );
                      }
                    }}
                  </FormItem>
                </Col>
              </Row>



              <FormItem
                label="Nombre Comercial"
                margin
                pattern
                max={200}
                required={!!camposObligatorios.nombreComercial}
                name="nombreComercial"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem placeholder="Nombre Comercial" />
              </FormItem>
              <FormItem
                label="Tipo Cliente"
                margin
                name="tipoClienteId"
                required
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <SelectItem
                  //width='120%'
                  placeholder="Tipo de Cliente"
                  onChange={this.onChangeTipoDeCliente.bind(this)}

                >
                  {this.state.objetoTipoDeCliente}
                </SelectItem>
              </FormItem>
              <FormItem
                name="vendedorId"
                fieldKey="vendedorId"
                label="Vendedor"
                margin
                required={!!camposObligatorios.vendedorId}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <SelectItem placeholder="Vendedor">
                  {this.state.objetoVendedores}
                </SelectItem>
              </FormItem>
              <FormItem
                name="canalDeVentaId"
                fieldKey="canalDeVentaId"
                label="Canal"
                margin
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <SelectItem placeholder="Canal" allowClear>
                  {this.state.objetoCanalesVenta}
                </SelectItem>
              </FormItem>
              <FormItem
                name="regimenFiscalId"
                label="R. Fiscal"
                margin
                required={!!camposObligatorios.regimenFiscalId}
                tooltip={{ title: "Campo necesario para facturación" }}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <SelectItem onChange={this.onChangeRegimenFiscal.bind(this)} placeholder="Regimen Fiscal">
                  {this.state.objetoRegimenFiscal}
                </SelectItem>
              </FormItem>
              <FormItem
                name="usoDeCFDIID"
                label="Uso de CFDI"
                margin
                required={!!camposObligatorios.usoDeCFDIID}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <SelectItem placeholder="Uso de CFDI">
                  {this.state.objetoUsosDeCFDI}
                </SelectItem>
              </FormItem>
              <FormItem
                label="Correo"
                name="correo"
                pattern
                max={200}
                email
                margin
                required={!!camposObligatorios.correo}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem placeholder="Correo" />
              </FormItem>
            </TabPane>

            <TabPane tab="Direcciones" key="2" forceRender>
              <FormInitial.List name="direcciones">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                      <>
                        {arrayKey === 0 && <HeaderItem>DIRECCION DE FACTURACION</HeaderItem>}
                        {arrayKey === 0 && <p style={{ textAlign: 'center' }}>Campos necesarios para facturación</p>}
                        <Row>
                          <Col span={24}>
                            <HeaderItem>DIRECCION</HeaderItem>
                            <BoxItem>
                              <Row>
                                <Col span={16} xs={24} sm={24} lg={16} xl={16}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "calle"]}
                                    fieldKey={[fieldKey, "calle"]}
                                    label="Dirección"
                                    max={200}
                                    margin
                                    pattern
                                    labelCol={{ span: 3 }}
                                    wrapperCol={{ span: 21 }}
                                  >
                                    <InputItem
                                      placeholder="Calle"
                                      width="98%"
                                    />
                                  </FormItem>
                                </Col>
                                <Col span={4} xs={24} sm={24} lg={4} xl={4}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "numeroCalle"]}
                                    fieldKey={[fieldKey, "numeroCalle"]}
                                    margin
                                    labelCol={{ span: 0 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <InputItem
                                      placeholder="Número"
                                      numeroCalle
                                      width="98%"
                                    />
                                  </FormItem>
                                </Col>
                                <Col span={4} xs={24} sm={24} lg={4} xl={4}>
                                  <FormItem
                                    name={[name, "numeroInterior"]}
                                    fieldKey={[fieldKey, "numeroInterior"]}
                                    margin
                                    pattern
                                    labelCol={{ span: 0 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <InputItem
                                      placeholder="Interior"
                                      width="98%"
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "coloniaId"]}
                                    fieldKey={[fieldKey, "coloniaId"]}
                                    label="C.P."
                                    margin
                                    required={arrayKey === 0}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <SelectItem placeholder="Código Postal"
                                      onSearch={(coloniaId) => {
                                        this.onSearchColonia(coloniaId, arrayKey)
                                      }}
                                      onSelect={(coloniaId) => {
                                        this.onSelectColoniaId(coloniaId, arrayKey)
                                      }}
                                    >
                                      {!this.state.objetoColonias[
                                        fieldKey
                                      ] ? (
                                        <Option disabled>
                                          Eliga primero un municipio
                                        </Option>
                                      ) : (
                                        this.state.objetoColonias[fieldKey]
                                      )}
                                      <Option disabled>Busque por codigo postal</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={16} xs={24} sm={24} lg={16} xl={16}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "colonia"]}
                                    fieldKey={[fieldKey, "colonia"]}
                                    label="Colonia"
                                    margin
                                    pattern
                                    labelCol={{ span: 3 }}
                                    wrapperCol={{ span: 21 }}
                                  >
                                    <InputItem placeholder="Colonia" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "municipioId"]}
                                    fieldKey={[fieldKey, "municipioId"]}
                                    margin
                                    labelCol={{ span: 0 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <SelectItem
                                      placeholder="Municipio"
                                      width="98%"
                                      onChange={(e) =>
                                        this.onChangeMunicipio(e, fieldKey)
                                      }
                                    >
                                      {!this.state.objetoMunicipios[
                                        fieldKey
                                      ] ? (
                                        <Option disabled>
                                          Eliga primero un estado
                                        </Option>
                                      ) : (
                                        this.state.objetoMunicipios[
                                        fieldKey
                                        ]
                                      )}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "estadoId"]}
                                    fieldKey={[fieldKey, "estadoId"]}
                                    margin
                                    labelCol={{ span: 0 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <SelectItem
                                      placeholder="Estado"
                                      width="98%"
                                      onChange={(e) =>
                                        this.onChangeEstado(e, fieldKey)
                                      }
                                    >
                                      {this.state.objetoEstados}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                  <FormItem
                                    {...restField}
                                    name={[name, "paisId"]}
                                    fieldKey={[fieldKey, "paisId"]}
                                    margin
                                    labelCol={{ span: 0 }}
                                    wrapperCol={{ span: 24 }}
                                  >
                                    <SelectItem
                                      placeholder="Pais"
                                      width="98%"
                                    >
                                      {this.state.objetoPaises}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                            </BoxItem>
                            <FormItem noStyle>
                              <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                                <ButtonItem
                                  type="primary"
                                  danger
                                  onClick={() => remove(name)}
                                // block
                                // icon={<MinusCircleOutlined />}
                                >
                                  Eliminar Dirección
                                </ButtonItem>
                              </div>
                            </FormItem>
                          </Col>
                        </Row>
                      </>
                    ))}
                    <FormItem noStyle>
                      <ButtonItem
                        style={{ marginTop: 10, marginBottom: 10 }}
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Agregar Dirección
                      </ButtonItem>
                    </FormItem>
                  </>
                )}
              </FormInitial.List>

            </TabPane>
            <TabPane tab="Retenciones" tabKey={3} key={3} forceRender>
              <HeaderItem>RETENCIONES</HeaderItem>
              <BoxItem>
                <FormInitial.List
                  name="retenciones"
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ name }, arrayKey) => (
                        <Row>
                          <Col span={22}>
                            <FormItem
                              name={[name, "retencionId"]}
                              fieldKey={[arrayKey, "retencionId"]}
                              required
                              margin
                              noStyle
                            >
                              <SelectItem width='100%' placeholder="Retención">
                                {this.state.objetoRetenciones}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col span={2}>
                            <div style={{ textAlign: 'center' }}>
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                              />
                            </div>
                          </Col>
                        </Row>
                      ))}
                      <div style={{ textAlign: 'center' }}>
                        <ButtonItem
                          type="primary"
                          onClick={() => add()}
                          icon={<PlusOutlined />}
                        >
                          Agregar
                        </ButtonItem>
                      </div>
                    </>
                  )}
                </FormInitial.List>
              </BoxItem>
            </TabPane>

            {this.props.insumosXCliente && (
              <TabPane tab="Insumos" key="4" forceRender>
                <FormItem
                  label="Activar Insumos x Cliente"
                  name="insumosXCliente"
                  margin
                  initialValue={false}
                  valuePropName="checked"
                  tooltip="Al activarlo, este cliente solo podrá comprar los insumos configurados aquí, y en sus ventas/pedidos/cotizaciones y PDFs verá el nombre alterno en vez del nombre interno."
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 18 }}
                >
                  <SwitchItem />
                </FormItem>

                <FormItem shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    if (!getFieldValue("insumosXCliente")) {
                      return (
                        <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                          Active "Insumos x Cliente" para configurar los insumos y nombres alternos de este cliente.
                        </p>
                      );
                    }
                    return (
                      <>
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: 10 }}>
                          <ButtonItem
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => this.abrirModalInsumoPersonalizado()}
                          >
                            Agregar Insumo
                          </ButtonItem>
                        </div>
                        <TableItemDinamico
                          size="small"
                          dataSource={this.state.insumosPersonalizadosVista}
                          totalRecords={this.state.insumosPersonalizadosTotal}
                          onFetchData={this.actualizarVistaInsumosPersonalizados.bind(this)}
                          rowKey={(value) => value._key || value.insumoId}
                          columns={[
                            { title: "Clave", dataIndex: "claveInterna", key: "claveInterna", buscar: "claveInterna", width: 90 },
                            { title: "Insumo", dataIndex: "descripcion", key: "descripcion", buscar: "descripcion" },
                            { title: "Nombre para el cliente", dataIndex: "nombreAlternativo", key: "nombreAlternativo", buscar: "nombreAlternativo" },
                            { title: "Clave Cliente", dataIndex: "clave", key: "clave", buscar: "clave", width: 100 },
                            { title: "Precio Unitario", dataIndex: "precio", key: "precio", width: 110 },
                            { title: "Unidad", dataIndex: "unidadNombre", key: "unidadNombre", buscar: "unidadNombre", width: 120 },
                            {
                              title: "Acciones",
                              dataIndex: "acciones",
                              key: "acciones",
                              width: 100,
                              render: (_, record) => (
                                <div className="acciones-container">
                                  <ButtonItem
                                    size="small"
                                    icon={<EditOutlined />}
                                    onClick={() => this.abrirModalInsumoPersonalizado(record)}
                                  />
                                  <Popconfirm
                                    title="¿Eliminar este insumo personalizado?"
                                    onConfirm={() => this.eliminarInsumoPersonalizado(record)}
                                    okText="Si"
                                    cancelText="No"
                                  >
                                    <ButtonItem size="small" danger icon={<DeleteOutlined />} />
                                  </Popconfirm>
                                </div>
                              ),
                            },
                          ]}
                        />
                      </>
                    );
                  }}
                </FormItem>
              </TabPane>
            )}

            {this.props.insumosXCliente && (
              <TabPane tab="Subir Insumos" key="5" forceRender>
                <FormItem shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    if (!getFieldValue("insumosXCliente")) {
                      return (
                        <p style={{ textAlign: "center", margin: 0, color: "#999" }}>
                          Active "Insumos x Cliente" en la pestaña de Insumos para poder subir por Excel.
                        </p>
                      );
                    }
                    return (
                      <SeccionSubirInsumosCliente
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        insumosYaConfigurados={this.state.insumosPersonalizados.map((i) => i.insumoId)}
                        onConfirmar={(filas, limpiar) => this.confirmarSubidaExcelInsumos(filas, limpiar)}
                      />
                    );
                  }}
                </FormItem>
              </TabPane>
            )}
          </Tabs>

          <FormItem>
            <ButtonItem type="primary" htmlType="submit" loading={this.state.loading}>
              Guardar
            </ButtonItem>
          </FormItem>
        </Form>

        <ModalInsumoParaCliente
          visible={this.state.modalInsumoPersonalizadoVisible}
          item={this.state.insumoPersonalizadoEditando}
          insumosYaConfigurados={this.state.insumosPersonalizados.map((i) => i.insumoId)}
          onCancel={() => this.cerrarModalInsumoPersonalizado()}
          onGuardar={(valores) => this.guardarInsumoPersonalizado(valores)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  insumosXCliente: state.empresa.insumosXCliente,
});

export default connect(mapStateToProps)(AgregarCliente);
